import { ScreenFrame } from '@/components/Screen';
import { MetricCard, MetricGrid, SectionCard } from '@/components/DataList';
import { distributor, tahweel } from '@/api/endpoints';
import { type JsonMap } from '@/api/client';
import { useAsync } from '@/hooks/useAsync';
import { ErrorBox, Loading, Money } from '@/components/ui';
import { str } from '@/utils/format';

export function ReportsScreen() {
  const state = useAsync(
    async () => {
      const [dist, tah] = await Promise.all([
        distributor.reports(),
        tahweel.reportsSummary(),
      ]);
      return {
        success: true as const,
        distributor: dist.success ? (dist as JsonMap) : null,
        tahweel: tah.success ? (tah as JsonMap) : null,
        error:
          !dist.success && !tah.success
            ? String(dist.error ?? tah.error ?? 'تعذر تحميل التقارير')
            : '',
      };
    },
    (p) => ({
      distributor: (p.distributor as JsonMap | null) ?? null,
      tahweel: (p.tahweel as JsonMap | null) ?? null,
      error: str(p.error, ''),
    }),
  );

  if (state.loading) return <Loading />;
  if (state.error) return <ErrorBox message={state.error} onRetry={state.reload} />;
  if (state.data?.error) return <ErrorBox message={state.data.error} onRetry={state.reload} />;

  const d = state.data?.distributor;
  const t = state.data?.tahweel;

  return (
    <ScreenFrame mode="customer" title="تقارير الموزع">
      {d ? (
        <SectionCard title="ملخص الموزع">
          <MetricGrid>
            <MetricCard title="عدد الطلبات" value={str(d.orders_count ?? d.total_orders)} />
            <MetricCard
              title="إجمالي المبيعات"
              value={<Money value={d.sales_total ?? d.total_sales} />}
            />
            <MetricCard title="الأرباح" value={<Money value={d.profit ?? d.total_profit} />} />
          </MetricGrid>
        </SectionCard>
      ) : null}
      {t ? (
        <SectionCard title="ملخص التحويل">
          <MetricGrid>
            <MetricCard title="العمليات" value={str(t.operations_count ?? t.count)} />
            <MetricCard title="الإجمالي" value={<Money value={t.total ?? t.amount} />} />
            <MetricCard title="الديون" value={<Money value={t.debts_total ?? t.debts} />} />
          </MetricGrid>
        </SectionCard>
      ) : null}
    </ScreenFrame>
  );
}
